import { makeStyles } from '@eagleview/ev-comp-library';

export default makeStyles((theme) => ({
  container: {
    display: 'flex',
    width: '400px',
    zIndex: '10000',
    justifyContent: 'space-between',
    position: 'absolute',
    margin: `${theme.spacing(0.25)}px ${theme.spacing(0)}px`,
    alignItems: 'center',
    height: '30px',
  },
  icon: {
    marginRight: theme.spacing(0.5),
    color: theme.evPalette.charcoal['600'],
    '&:hover': {
      color: theme.evPalette.charcoal['900'],
    },
  },
  text: {
    textAlign: 'left',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '100%',
    fontSize: theme.spacing(1.75),
    marginLeft: theme.spacing(1),
  },
  link: {
    color: theme.evPalette.salt['100'],
    backgroundColor: theme.evPalette.rose['800'],
    '&:hover': {
      backgroundColor: theme.evPalette.rose['700'],
    },
    fontSize: theme.spacing(1.75),
    textTransform: 'none',
    whiteSpace: 'nowrap',
    flexShrink: 0,
    height: '30px',
  },
  drag: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexGrow: 1,
    minWidth: '0',
    '&:hover': {
      cursor: 'grab',
    },
  },
}));
